export default "__VITE_ASSET__Pa56MFtG__"